export default __webpack_public_path__ + "static/media/long.f2722355.png";